<hb-dynamic-details-dialog
  *ngIf="selectedFailureMode"
  [modalTitle]="title"
  [item]="selectedFailureMode"
  [controls]="controls"
  (onSaved)="onSaved()"
></hb-dynamic-details-dialog>
